import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import {ContactImportFileContainerModel} from '../../../../../../models/aggregates/crm/contact';
import { ApiVisa } from '../../shared';

@Injectable({providedIn: 'root'})
export class ContactImportFileService extends BaseApiTemplateService<ContactImportFileContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CRM_PREFIX + 'contacts/import-file-hdrs';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CRM_PREFIX + 'contacts/import-file-hdrs';
    this.httpClient = http;
  }
  public upload(formData: FormData, type: string, visa: ApiVisa) {
		let url = visa.api_domain_url + this.endpoint_path;

		if (this.endpoint_path && visa.api_domain_url) {
			url = url + "/" + type;
		}
		return this.httpClient.post(url, formData, this.getHttpHeader(visa));
	}

}